export default "__VITE_ASSET__9824a482__"